// From https://stackoverflow.com/a/47537006/481565
function getLocale() {
  return navigator.languages && navigator.languages.length
    ? navigator.languages[0]
    : navigator.language;
}

// This list is aggregated from the following two sources:
// - https://github.com/moment/moment/tree/master/locale
// - https://github.com/iamkun/dayjs/tree/dev/src/locale
const localesByStartOfWeek = {
  // Starts on Monday
  '1': new Set(
    'af,am,ar-ma,ar-tn,az,be,bg,bi,bm,br,bs,ca,cs,cv,cy,da,de,de-at,de-ch,el,en-gb,en-ie,en-nz,en-sg,eo,es,es-do,et,eu,fi,fil,fo,fr,fr-ch,fy,ga,gd,gl,gom-latn,hr,hu,hy-am,id,is,it,it-ch,jv,ka,kk,km,ky,lb,lt,lv,me,mi,mk,ms,ms-my,mt,my,nb,nl,nl-be,nn,oc-lnc,pl,pt,ro,ru,sd,se,sk,sl,sq,sr,sr-cyrl,ss,sv,sv-fi,sw,tet,tg,tk,tl-ph,tlh,tr,tzl,ug-cn,uk,ur,uz,uz-latn,vi,yo,zh,zh-cn'.split(
      ',',
    ),
  ),
  // Starts on Saturday
  '6': new Set('ar,ar-ly,fa,ku,tzm,tzm-latn'.split(',')),
};

export const locale = (getLocale() || 'en-US').toLowerCase();
export const lang = locale.split('-')[0] || 'en';

let selectedStartOfWeek: number | undefined;
let fallbackStartOfWeek: number | undefined;

for (let [dow, localeSet] of Object.entries(localesByStartOfWeek)) {
  if (localeSet.has(locale)) {
    selectedStartOfWeek = Number(dow);
  }
  if (localeSet.has(lang)) {
    fallbackStartOfWeek = Number(dow);
  }
}

export const startOfWeek = selectedStartOfWeek ?? fallbackStartOfWeek ?? 0;
